import React from 'react';
import { Link } from '@blaze-cms/nextjs-components';
import isObject from './is-object';
import removeUnwantedCharacters from './remove-unwanted-characters';
const getParsedPropValues = ({
  propertiesToDisplay,
  props,
  enableLink,
  shouldStrip
}) => propertiesToDisplay.map(property => {
  const [filteredProperty, subtype] = property.split('.');
  const value = props[filteredProperty];
  if (Array.isArray(value)) {
    return value.map((prop, index) => {
      const propValue = subtype ? prop[subtype] : prop;
      const sanitizedValue = shouldStrip ? removeUnwantedCharacters(propValue) : propValue;
      const isLastValue = index === value.length - 1;
      const parsedValue = isLastValue ? sanitizedValue : sanitizedValue.concat(', ');
      const linkKey = [filteredProperty, prop[subtype], index].join('-');
      return enableLink && prop.url ? /*#__PURE__*/React.createElement(Link, {
        key: linkKey,
        href: prop.url
      }, parsedValue) : parsedValue;
    });
  }
  if (isObject(value)) {
    return shouldStrip ? removeUnwantedCharacters(value[subtype]) : value[subtype];
  }
  return shouldStrip ? removeUnwantedCharacters(value) : value;
}).filter(Boolean);
export default getParsedPropValues;
//# sourceMappingURL=get-parsed-prop-values.js.map